import { useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery } from '@occc/graphql';
import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';

export const useRetailerNetworkScanDataTobaccoSubmissionsOverview = (
  retailerNetworkUuidEquals: string,
) => {
  return useRetailerNetworkScanDataTobaccoSubmissionsOverviewQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter: {
        retailerNetworkUuidEquals,
      },
    },
  });
};
